import { render, staticRenderFns } from "./PromotionListTable.vue?vue&type=template&id=551d4280&scoped=true"
import script from "./PromotionListTable.vue?vue&type=script&lang=js"
export * from "./PromotionListTable.vue?vue&type=script&lang=js"
import style0 from "./PromotionListTable.vue?vue&type=style&index=0&id=551d4280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d4280",
  null
  
)

export default component.exports